<template>
  <div class="goodList">
    <div
      v-for="(item, index) in searchList"
      :key="index"
      class="item acea-row row-between-wrapper"
    >
      <!-- <div class="pictrue">
        <img
          v-if="item.HasImage"
          v-lazy="item.ImageUrl"
          alt="img"
          class="image"
        />
      </div>-->
      <div class="underline">
        <div class="text">
          <div class="line1">{{ item.Name }}</div>
          <div class="line1">{{ similar(item.Name) }}</div>
          <!-- 
          <div v-if="item.KeyNo" class="vip-money acea-row row-middle">
            <div class="vip"></div>
            <span class="num">KeyNo：{{ item.KeyNo }}</span>
          </div>
          <div v-if="item.Name" class="vip-money acea-row row-middle">
            <div class="vip"></div>
            <span class="num">公司名称：{{ item.Name }}</span>
          </div>
          <div v-if="item.OperName" class="vip-money acea-row row-middle">
            <div class="vip"></div>
            <span class="num">法人名称：{{ item.OperName }}</span>
          </div>
          <div v-if="item.StartDate" class="vip-money acea-row row-middle">
            <div class="vip"></div>
            <span class="num">成立日期：{{ item.StartDate }}</span>
          </div>
          <div v-if="item.Status" class="vip-money acea-row row-middle">
            <div class="vip"></div>
            <span class="num">企业状态：{{ item.Status }}</span>
          </div>
          <div v-if="item.No" class="vip-money acea-row row-middle">
            <div class="vip"></div>
            <span class="num">注册号：{{ item.No }}</span>
          </div>
          <div v-if="item.CreditCode" class="vip-money acea-row row-middle">
            <div class="vip"></div>
            <span class="num">社会统一信用代码：{{ item.CreditCode }}</span>
          </div>-->
        </div>
      </div>
      <!-- <div
        class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
      ></div>-->
    </div>
  </div>
</template>
<script>
import { similar } from "@utils/bc";
export default {
  name: "CompanyList",
  props: {
    searchList: {
      type: Array,
      default: () => []
    },
    searchInfo: {
      type: String,
      default: ""
    }
  },
  methods: {
    similar(name) {
      console.log(name);
      console.log(this.searchInfo);

      const numVale = similar(name, this.searchInfo);
      if (0 <= numVale && numVale <= 1 / 2) return "低";
      else if (1 / 2 < numVale && numVale <= 3 / 4) return "中";
      else if (3 / 4 < numVale && numVale <= 1) return "高";
    }
  }
};
</script>
<style scoped>
.goodList .item {
  margin: 0 50px;
  padding: 24px 0;
}
.goodList .item .underline {
  padding: 0;
}
.goodList .item .text .line1 {
  font-size: 16px;
  font-weight: normal;
}
.goodList .item .text {
  display: flex;
  width: 100%;
  justify-content: space-around;
  text-align: center;
}
</style>
